// components/YearRangeSelector.js
import React, { Component } from "react";
import { withState } from "react-searchkit";
import debounce from 'lodash.debounce';
import { Accordion, AccordionContent, AccordionTitle, Button, Grid, GridRow, GridColumn, Dropdown, Icon } from "semantic-ui-react";

class BBoxComponent extends Component {
  constructor(props) {
    super(props);
    const selectedRelation = props.currentQueryState.filters.find((f) => f[0] === "relation");
    const relation = selectedRelation ? selectedRelation[1] : "intersects";

    const selectedBBox = props.currentQueryState.filters.find((f) => f[0] === "bbox");
    const bbox = selectedBBox ? selectedBBox[1].split(",").map((v) => parseFloat(v)) : [];
    this.state = {
      relation: relation,
      bbox: bbox,
      active: false,
      errors: {},
    }
  }

  // Debounce the search by 300ms due to slider
  debouncedQuery = debounce((value) => {
    const { updateQueryState } = this.props;
    updateQueryState(value);
  }, 300);

  handleBBoxChange(newBBox) {
    const newBBoxArray = Array.from(newBBox);
    this.setState({ bbox: newBBoxArray });

    const { currentQueryState } = this.props;
    var hasBBox = currentQueryState.filters.some((x) => x[0] === "bbox");
    var filters = currentQueryState.filters.filter((f) => {
      return f[0] !== "bbox";
    })

    const parsed = newBBoxArray.map((x) => parseFloat(x));
    const allValid =
      parsed.length === 4 &&
      parsed.every((x) => !isNaN(x) && x !== null) &&
      parsed[0] <= parsed[2] &&
      parsed[1] <= parsed[3];
    const filter = ["bbox", `${newBBoxArray[0]},${newBBoxArray[1]},${newBBoxArray[2]},${newBBoxArray[3]}`]
    if (allValid) {
      filters = [...filters, filter]
    } else if (!hasBBox) {
      return;
    }
    this.debouncedQuery({
      ...currentQueryState,
      filters,
    });
  }
  handleRelationChange(newRelation) {
    this.setState({ relation: newRelation });
    const { currentQueryState } = this.props;
    const filters = currentQueryState.filters.filter((f) => {
      return f[0] !== "relation";
    })
    this.debouncedQuery({
      ...currentQueryState,
      filters: [
        ...filters,
        ["relation", newRelation]
      ],
    });
  }

  handleInputChange(index, value) {
    if (index !== "relation") {
      const newBBox = [...this.state.bbox];
      newBBox[index] = value;
      this.handleBBoxChange(newBBox);
    } else if (index === "relation") {
      this.handleRelationChange(value);
    }
  }

  clear() {
    const newBBox = this.state.bbox.map((e) => undefined);
    this.handleBBoxChange(newBBox);
  }

  relations = [
    {
      key: "intersects",
      text: "Intersects",
      value: "intersects"
    },
    {
      key: "within",
      text: "Within",
      value: "within"
    },
    {
      key: "disjoint",
      text: "Disjoint",
      value: "disjoint"
    },
    {
      key: "contains",
      text: "Contains",
      value: "contains"
    }
  ]


  render() {
    const { active, bbox } = this.state;

    const hasActiveBBox =
      bbox.length === 4 &&
      bbox.every(
        (value) =>
          value !== "" &&
          value !== undefined &&
          !Number.isNaN(Number(value))
      );

    return (
      <Accordion fluid>
        <AccordionTitle
          active={active}
          onClick={() =>
            this.setState(({ active: currentActive }) => ({
              active: !currentActive,
            }))
          }
        >
          <Icon
            name={active ? "angle down" : "angle right"}
            aria-hidden="true"
          />

          BBox

          {hasActiveBBox && (
            <Button
              className="mini basic right floated"
              onClick={(event) => {
                event.stopPropagation();
                this.clear();
              }}
              aria-label="Clear BBox filter"
              title="Clear BBox filter"
            >
              Clear
            </Button>
          )}
        </AccordionTitle>

        <AccordionContent active={active}>
          <Grid verticalAlign="middle">
              <GridRow>
                <GridColumn width={8}>
                  min. Longitude
                </GridColumn>
                <GridColumn width={8} className="ui fluid input">
                  <input
                    type="number"
                    value={this.state.bbox?.[0] ?? ""}
                    min={-180}
                    max={this.state.bbox?.[2] ?? 180}
                    onChange={(e) => this.handleInputChange(0, e.target.value)}
                  />
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={8}>min. Latitude</GridColumn>
                <GridColumn width={8} className="ui fluid input">
                  <input
                    type="number"
                    value={this.state.bbox?.[1] ?? ""}
                    min={-90}
                    max={this.state.bbox?.[3] ?? 90}
                    onChange={(e) => this.handleInputChange(1, e.target.value)}
                  />
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={8}>max. Longitude</GridColumn>
                <GridColumn width={8} className="ui fluid input">
                  <input
                    type="number"
                    value={this.state.bbox?.[2] ?? ""}
                    min={this.state.bbox?.[0] ?? -180}
                    max={180}
                    onChange={(e) => this.handleInputChange(2, e.target.value)}
                  />
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={8}>max. Latitude</GridColumn>
                <GridColumn width={8} className="ui fluid input">
                  <input
                    type="number"
                    value={this.state.bbox?.[3] ?? ""}
                    min={this.state.bbox?.[1] ?? -90}
                    max={90}
                    onChange={(e) => this.handleInputChange(3, e.target.value)}
                  />
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={8}>Relation</GridColumn>
                <GridColumn width={8}>
                  <Dropdown
                    fluid
                    selection
                    options={this.relations}
                    value={this.state.relation}
                    onChange={(e, d) => this.handleInputChange("relation", d.value)}
                  />
                </GridColumn>
              </GridRow>
        </Grid>
        </AccordionContent>
      </Accordion>
    );
  }
}

export const Bbox = withState(BBoxComponent);
